let I18nManager = {
  isRTL: false,
};

export default I18nManager;
